import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../api/config';

// const url = `${PREFIX_URL}/v01/documentActivityLog`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/activities`;

type getActivityLogsResponse = {
  data: any[];
};

export const getActivityLogs = ({
  inboxEntryId,
  projectId,
  emailId,
}): Promise<getActivityLogsResponse> => {
  return axios.get(generateRoutePath(url, { projectId, inboxEntryId, emailId }));
};

export const acivityLogsKeys = {
  all: ['activityLogs'] as const,
  list: (projectId: string) => [INBOX_API_KEY, ...acivityLogsKeys.all, projectId] as const,
  detail: ({
    projectId,
    emailId,
    inboxEntryId,
  }: {
    projectId: string;
    emailId: number;
    inboxEntryId: number;
  }) => [INBOX_API_KEY, ...acivityLogsKeys.all, projectId, { emailId, inboxEntryId }] as const,
};

type QueryFnType = typeof getActivityLogs;

type useActivityLogsOptions = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useActivityLogs = ({ projectId, config, ...otherParams }: useActivityLogsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...acivityLogsKeys.all, projectId, otherParams],
    queryFn: () => getActivityLogs({ projectId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
